import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    requestedBy: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: theme.spacing(1),
    },
  })
);
